var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_2465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9954 16.6627V16.662H17.9999V10.0605C17.9999 6.83095 17.3047 4.3432 13.5292 4.3432C11.7142 4.3432 10.4962 5.3392 9.99895 6.28345H9.94645V4.6447H6.3667V16.662H10.0942V10.7115C10.0942 9.1447 10.3912 7.6297 12.3314 7.6297C14.2432 7.6297 14.2717 9.4177 14.2717 10.812V16.6627H17.9954Z",
    fill: "#2D64BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.297119 4.64551H4.02912V16.6628H0.297119V4.64551Z",
    fill: "#2D64BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1615 0C0.96825 0 0 0.96825 0 2.1615C0 3.35475 0.96825 4.34325 2.1615 4.34325C3.35475 4.34325 4.323 3.35475 4.323 2.1615C4.32225 0.96825 3.354 0 2.1615 0V0Z",
    fill: "#2D64BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_2465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.42504d63c6a9420305fa96a46a91a118.svg";
export { ForwardRef as ReactComponent };